import { render, staticRenderFns } from "./Mss.vue?vue&type=template&id=483c3efe"
import script from "./Mss.vue?vue&type=script&lang=js"
export * from "./Mss.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports